import { List, Record } from 'immutable';
import TableRowLimit from 'SalesContentIndexUI/constants/TableRowLimit';
import SearchSortRecord from 'SalesContentIndexUI/data/records/SearchSortRecord';
import { FOLDER_ID_FIELD, TEAM_ID_FIELD, USER_ID_FIELD } from 'SalesContentIndexUI/data/constants/SearchFields';
import filter from 'SalesContentIndexUI/data/utils/filter';
const SearchQueryBaseRecord = Record({
  query: '',
  limit: 25,
  offset: 0,
  filters: List(),
  sorts: List(),
  contentTypesToHydrate: List()
}, 'SearchQueryRecord');
export default class SearchQueryRecord extends SearchQueryBaseRecord {
  getCurrentPage() {
    return Math.floor(this.offset / this.limit + 1);
  }
  getFolderFilter() {
    return this.filters.find(searchFilterRecord => searchFilterRecord.field === FOLDER_ID_FIELD);
  }
  getTeamFilter() {
    return this.filters.find(searchFilterRecord => searchFilterRecord.field === TEAM_ID_FIELD);
  }
  getUserFilter() {
    return this.filters.find(searchFilterRecord => searchFilterRecord.field === USER_ID_FIELD);
  }
  setFolderFilter(folderId) {
    const folderFilter = folderId ? filter(FOLDER_ID_FIELD, folderId) : filter(FOLDER_ID_FIELD);
    const hasFolderFilter = !!this.getFolderFilter();
    let updatedFilters;
    if (!hasFolderFilter) {
      updatedFilters = this.filters.push(folderFilter);
    } else {
      updatedFilters = this.filters.map(searchFilterRecord => {
        if (searchFilterRecord.field !== FOLDER_ID_FIELD) {
          return searchFilterRecord;
        }
        return folderId ? filter(FOLDER_ID_FIELD, folderId) : filter(FOLDER_ID_FIELD);
      });
    }
    return this.merge({
      query: '',
      filters: updatedFilters
    });
  }
  mergeWithQueryParams({
    queryParams,
    selectedViewFilter
  }) {
    const {
      q = '',
      folder,
      field,
      order,
      page = 1,
      id
    } = queryParams;
    const updatedSort = field && order ? List([SearchSortRecord({
      field,
      order
    })]) : this.sorts;
    const updatedOffset = (page - 1) * TableRowLimit.INDEX;
    const updatedSearchQuery = this.merge({
      query: q,
      filters: selectedViewFilter.getFilters(id),
      sorts: updatedSort,
      offset: updatedOffset
    });
    return folder ? updatedSearchQuery.setFolderFilter(folder) : updatedSearchQuery;
  }
}